module.exports = __webpack_public_path__ + "img/snap.49ed7c10.png";